import { useState } from "react";
import { Menu, X, Play } from "lucide-react";

const LINKS = [
  { label: "Episodes", href: "#episodes", id: "episodes" },
  { label: "Next Week", href: "#next-week", id: "next-week" },
  { label: "Feed", href: "#feed", id: "feed" },
  { label: "Letters", href: "#letters", id: "letters" },
  { label: "About", href: "#about", id: "about" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed inset-x-0 top-0 z-50 border-b border-bone/10 bg-black/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <a
          href="#top"
          data-testid="header-logo"
          className="font-display text-xl tracking-wide text-bone"
        >
          REEL <span className="italic text-ruby">vs</span> REAL
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-link-${link.id}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-300 hover:text-bone"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#latest"
            data-testid="nav-listen-cta"
            className="flex items-center gap-2 border border-ruby px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] text-ruby transition-colors duration-300 hover:bg-ruby hover:text-white"
          >
            <Play size={12} /> Listen
          </a>
        </nav>

        <button
          data-testid="mobile-menu-button"
          className="text-bone md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="border-t border-bone/10 bg-noir px-6 py-6 md:hidden"
          aria-label="Mobile"
        >
          <div className="flex flex-col gap-5">
            {LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                data-testid={`mobile-nav-link-${link.id}`}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors hover:text-bone"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#latest"
              data-testid="mobile-nav-listen-cta"
              onClick={() => setOpen(false)}
              className="mt-2 flex w-fit items-center gap-2 border border-ruby px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] text-ruby"
            >
              <Play size={12} /> Listen
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
